import { useAuth0 } from '@auth0/auth0-react'
import { emailService } from '@/services/emailService'
import { usePreferenciasUsuario } from '@/hooks/useConfiguracion'
import { useOrganizacion } from '@/core/providers/OrganizacionProvider'

type NotificationType =
  | 'email_nuevo_cliente'
  | 'email_nuevo_movimiento'
  | 'email_recordatorio_vencimiento'

export function useNotificaciones() {
  const { user, getAccessTokenSilently } = useAuth0()
  const { data: preferencias } = usePreferenciasUsuario()
  const { organizacionId } = useOrganizacion()

  const debeEnviar = (tipo: NotificationType) => {
    if (!preferencias) {
      const defaults: Record<NotificationType, boolean> = {
        email_nuevo_cliente: true,
        email_nuevo_movimiento: false,
        email_recordatorio_vencimiento: true,
      }
      return defaults[tipo] ?? false
    }
    return (preferencias as unknown as Record<string, boolean>)[tipo] ?? false
  }

  const notificarNuevoCliente = async (cliente: {
    nombre: string
    cuit?: number | null
    honorarios_mensuales?: number
  }) => {
    if (!user?.email || !organizacionId || !debeEnviar('email_nuevo_cliente')) {
      return
    }

    try {
      const token = await getAccessTokenSilently()
      await emailService.enviarNotificacionNuevoCliente(token, user.email, cliente, organizacionId)
    } catch (error) {
      console.error('Error enviando notificacion de nuevo cliente:', error)
    }
  }

  const notificarNuevoMovimiento = async (movimiento: {
    clienteNombre: string
    concepto: string
    monto: number
    tipo: 'debe' | 'haber'
  }) => {
    if (!user?.email || !organizacionId || !debeEnviar('email_nuevo_movimiento')) {
      return
    }

    try {
      const token = await getAccessTokenSilently()
      await emailService.enviarNotificacionNuevoMovimiento(token, user.email, movimiento, organizacionId)
    } catch (error) {
      console.error('Error enviando notificacion de nuevo movimiento:', error)
    }
  }


  return {
    notificarNuevoCliente,
    notificarNuevoMovimiento,
    debeEnviar,
  }
}
